import React from 'react'
import {COLOR_CODE} from '@/utils/constants/colors'
import './_pageContainer.scss'
const PageContainer = ({children, background = COLOR_CODE._1D1D1D, borderRadius = '8px', height = '100%',minHeight}) => {
  return (
    <div className={'pc-container-position flex flex-col text-base'}>
      <div
        style={{
          '--dynamic-background': background,
          '--dynamic-border-radius': borderRadius,
          '--dynamic-height': height,
          '--dynamic-min-height': minHeight,
        }}
        className={'shadow pc-block mb-3 mt-4 flex w-full flex-col  p-6 text-white'}
        data-cy="page-content"
      >
        {children}
      </div>
    </div>
  )
}

export default React.memo(PageContainer)
